import { DriveItemType } from '@/drive/entities/DriveItem/DriveItem.types';
import { DriveItemId } from '@/drive/entities/DriveItemId';
import { DriveItemRequest } from '@/drive/types/DriveItemRequest';
import { PinnedItem, PinnedItemModel, PinnedItemType } from '@/forwarding/entities/PinnedItem/PinnedItem';

export class PinnedUrl implements PinnedItem {
  readonly id: string;
  readonly type = PinnedItemType.Url;
  readonly driveItemId: DriveItemId;
  readonly url: string;

  constructor(item: { id: DriveItemId; url: string }) {
    this.id = `${PinnedItemType.Url}-${item.id}`;
    this.driveItemId = item.id;
    this.url = item.url;
  }

  getUrl(): string {
    return this.url;
  }

  toDriveItemRequest(): DriveItemRequest {
    return { type: DriveItemType.Url, id: this.driveItemId };
  }

  toModel(): PinnedItemModel {
    return { type: this.type, driveItemId: this.driveItemId, url: this.url };
  }
}
